module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pgInner qukList",
    style: ('height:' + _vm.pageH + 'px;')
  }, [_c('div', {
    ref: "tabNavs",
    staticClass: "tabNavs"
  }, [_c('span', [_vm._v("客服快捷回复")]), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.goFrash
    }
  }, [_vm._v("刷新")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.goEdit('new')
      }
    }
  }, [_c('span', [_vm._v("新建")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "seekLine"
  }, [_c('div', {
    staticClass: "seekGp"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入内容"
    },
    on: {
      "input": function($event) {
        _vm.reInxList()
      }
    },
    model: {
      value: (_vm.listParams.question),
      callback: function($$v) {
        _vm.$set(_vm.listParams, "question", $$v)
      },
      expression: "listParams.question"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "inpGp"
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "状态"
    },
    on: {
      "change": function($event) {
        _vm.reInxList()
      }
    },
    model: {
      value: (_vm.listParams.status),
      callback: function($$v) {
        _vm.$set(_vm.listParams, "status", $$v)
      },
      expression: "listParams.status"
    }
  }, _vm._l((_vm.options2), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.name,
        "value": item.key
      }
    })
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "pgbody"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.listData,
      "header-row-class-name": "tableHead"
    },
    on: {
      "selection-change": _vm.tabSelect
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "30"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "question",
      "label": "标题"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                      " + _vm._s(_vm._f("datFormate")(scope.row.status, 1)) + "\n                 ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "updatedAt",
      "align": "center",
      "width": "240",
      "label": "发布时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "210"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 2 || scope.row.status == 3) ? _c('div', {
          staticClass: "ibtn"
        }, [_c('span', {
          on: {
            "click": function($event) {
              _vm.goEdit('edit', scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('div', {
          staticClass: "dvLine"
        })]) : _vm._e(), _vm._v(" "), (scope.row.status != 1) ? _c('div', {
          staticClass: "ibtn"
        }, [_c('span', {
          on: {
            "click": function($event) {
              _vm.goRemove(scope.row)
            }
          }
        }, [_vm._v("删除")]), _vm._v(" "), _c('div', {
          staticClass: "dvLine"
        })]) : _vm._e(), _vm._v(" "), (scope.row.status == 2 || scope.row.status == 3) ? _c('div', {
          staticClass: "ibtn"
        }, [_c('span', {
          on: {
            "click": function($event) {
              _vm.changeState(1, scope.row)
            }
          }
        }, [_vm._v("上架")]), _vm._v(" "), _c('div', {
          staticClass: "dvLine"
        })]) : _vm._e(), _vm._v(" "), (scope.row.status == 1) ? _c('div', {
          staticClass: "ibtn"
        }, [_c('span', {
          on: {
            "click": function($event) {
              _vm.changeState(2, scope.row)
            }
          }
        }, [_vm._v("下架")]), _vm._v(" "), _c('div', {
          staticClass: "dvLine"
        })]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), (_vm.listData.length > 0) ? _c('div', {
    staticClass: "table-footer"
  }, [_c('div', {
    staticClass: "btns"
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.changeState(1)
      }
    }
  }, [_vm._v("上架")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.changeState(2)
      }
    }
  }, [_vm._v("下架")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.goRemove()
      }
    }
  }, [_vm._v("删除")])], 1), _vm._v(" "), (_vm.allPages > 1) ? _c('el-pagination', {
    staticClass: "paging",
    attrs: {
      "current-page": _vm.pageStore.no,
      "page-count": _vm.allPages,
      "layout": "total, prev, pager, next, jumper",
      "total": _vm.allEls
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }) : _vm._e()], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-dbcf791e"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/Enterprise/banner/qukList.vue
// module id = 1573
// module chunks = 1